export default [
  {
    path: '/school/dept',
    component: () => import('./views/dept')
  },
  {
    path: '/school/type',
    component: () => import('./views/type'),
    children: [
      {
        path: "date",
        component: () => import('./views/type/date')
      },
      {
        path: "expert",
        component: () => import('./views/type/expert')
      }
    ]
  },
  {
    path: '/school/paiban',
    component: () => import('./views/paiban')
  }
]



// WEBPACK FOOTER //
// ./src/page/school/router.js